export class FormValueDto {
  public $type: string;
  public name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public value: any;
  public parent?: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(type: string, name: string, value: any, parent?: string) {
    this.$type = type;
    this.name = name;
    this.value = value;
    this.parent = parent;
  }
}
